import * as React from 'react';
import Paper from '@mui/material/Paper';
import { useLocation } from "react-router-dom";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const columns = [
  { id: 'pool', label: 'Bade i basseng', minWidth: 110, maxWidth: 200 },
  { id: 'gym', label: 'Aktivitet i gymsal', minWidth: 110, maxWidth: 200 },
  { id: 'hike', label: 'Gå tur', minWidth: 110, maxWidth: 200 },
  { id: 'horse', label: 'Drive med hest', minWidth: 110, maxWidth: 200 },
  { id: 'canoe', label: 'Utendørs vannaktivitet', minWidth: 110, maxWidth: 200 },
  { id: 'climbing', label: 'Klatring', minWidth: 110, maxWidth: 200 },
  { id: 'cycle', label: 'Sykling', minWidth: 110, maxWidth: 200 },
  { id: 'outdoor', label: 'Friluftsliv', minWidth: 110, maxWidth: 200 },
  { id: 'screen', label: 'Spill på skjerm', minWidth: 110, maxWidth: 200 },
  { id: 'playOutside', label: 'Leke ute', minWidth: 110, maxWidth: 200 },
  { id: 'musicMove', label: 'Bevegelse musikk', minWidth: 110, maxWidth: 200 },
  { id: 'alpin', label: 'Alpin', minWidth: 110, maxWidth: 200 },
  { id: 'skates', label: 'Skøyter', minWidth: 110, maxWidth: 200 },
  { id: 'skiing', label: 'Langrenn', minWidth: 110, maxWidth: 200 },

];

function createData(pool, gym, hike, horse, canoe, climbing, cycle, outdoor, screen, playOutside, musicMove, alpin, skates, skiing) {
  return { pool, gym, hike, horse, canoe, climbing, cycle, outdoor, screen, playOutside, musicMove, alpin, skates, skiing };
}



export default function UserTable() {
  const { state } = useLocation();
  const { gym, cycle, horse,
    pool, climbing, canoe, outdoor,
    playOutside, hike, screen, musicMove, alpin, skates, skiing } = state;

  const rows = [
    createData(pool, gym, hike, horse, canoe, climbing, cycle, outdoor, screen, playOutside, musicMove, alpin, skates, skiing),
  ];


  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, fontSize: 16, fontWeight: "bold" }}

                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format && typeof value === 'number'
                          ? column.format(value)
                          : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
